/* any functionality that external components need, and thus must be exported, goes in this file */
import React, { useRef } from 'react';
import { font, colors, spacing } from '@chegg-ui/theme';
import { css } from 'styled-components';
export var inputBorderWidth = '2px';
export var getBaseInputStyles = function getBaseInputStyles(_ref) {
  var errorText = _ref.errorText,
      disabled = _ref.disabled,
      isFocused = _ref.isFocused,
      hasLeadingIcon = _ref.hasLeadingIcon,
      hasTrailingIcon = _ref.hasTrailingIcon,
      isLabelHovered = _ref.isLabelHovered,
      ariaExpanded = _ref['aria-expanded'],
      customTheme = _ref.customTheme;
  return css(["border-radius:", ";position:relative;box-sizing:border-box;border-style:solid;border-width:", ";border-color:", ";", " font-family:", ";font-size:", ";color:", ";width:100%;line-height:", ";padding:calc(", " - ", ") calc(", " - ", ");", " display:flex;align-items:center;height:", ";text-overflow:ellipsis;background-color:", ";&::placeholder{color:", ";}&:hover{", " border-color:", ";}", " &:active,&:focus{border-width:", ";border-color:", ";box-shadow:", ";outline:none;}", " ", " ", " ", ""], customTheme.borderRadius, errorText ? customTheme.errorBorder : customTheme.defaultBorder, errorText ? customTheme.errorBorderColor : customTheme.defaultBorderColor, errorText && "\n    box-shadow: ".concat(customTheme.errorBoxShadow, ";"), font.family["default"], font.size.px16, customTheme.fontColor, customTheme.lineHeight, spacing.px8, inputBorderWidth, spacing.px16, inputBorderWidth, customTheme.showCaretDownIcon && "\n      padding-top: 1rem;\n      padding-bottom: .813rem;\n      padding-left: 1rem;\n    ", customTheme.height, errorText ? customTheme.errorBackgroundColor : colors.white, customTheme.placeholderColor, customTheme.showCaretDownIcon && "border-width: ".concat(customTheme.hoverBorder, ";"), customTheme.hoverBorderColor,
  /* istanbul ignore next */
  isLabelHovered && !disabled && "\n      border-width: ".concat(customTheme.hoverBorder, ";\n      border-color: ").concat(customTheme.hoverBorderColor, ";"), customTheme.showCaretDownIcon && customTheme.activeBorder, customTheme.activeBorderColor, customTheme.showCaretDownIcon && customTheme.activeBoxShadow,
  /* istanbul ignore next */
  (isFocused || ariaExpanded) && "\n      border-color: ".concat(customTheme.activeBorderColor, " !important;\n      box-shadow: ").concat(customTheme.activeBoxShadow, " !important;\n      border-width: ").concat(customTheme.showCaretDownIcon && customTheme.activeBorder, " !important;\n     "), disabled && "\n    background-color: ".concat(customTheme.disabledBackgroundColor, ";\n    &::placeholder {\n      color: ").concat(customTheme.disabledPlaceholderColor, ";\n    }\n    color: ").concat(customTheme.disabledColor, ";\n    border-color: ").concat(errorText ? customTheme.errorBorderColor : customTheme.disabledBorderColor, ";\n    border-width: ").concat(customTheme.disabledBorder, ";\n    &:hover,\n    &:focus,\n    &:active {\n      border-color: ").concat(errorText ? customTheme.errorBorderColor : customTheme.disabledBorderColor, ";\n      border-width: ").concat(customTheme.disabledBorder, ";\n      outline: none;\n    }\n  "), hasTrailingIcon && "padding-right: 2rem;", hasLeadingIcon && "padding-left: 3rem;");
};
export var getFloatingInputStyles = function getFloatingInputStyles(_ref2) {
  var errorText = _ref2.errorText,
      disabled = _ref2.disabled,
      isFocused = _ref2.isFocused,
      hasLeadingIcon = _ref2.hasLeadingIcon,
      hasTrailingIcon = _ref2.hasTrailingIcon,
      ariaExpanded = _ref2['aria-expanded'],
      adjustToBackgroundColor = _ref2.adjustToBackgroundColor,
      customTheme = _ref2.customTheme;
  return css(["background:transparent;box-sizing:border-box;border:none;border-bottom:", " solid;border-color:", ";font-family:", ";font-size:", ";color:", ";width:100%;line-height:", ";display:block;text-overflow:ellipsis;padding:", " 0 calc(", " - ", ") 0;&:hover{border-width:", ";border-color:", ";}&:active,&:focus{border-color:", ";border-width:", ";outline:none;}", " ", " ", " ", ""], errorText ? customTheme.errorBorder : customTheme.defaultBorder, "".concat(errorText ? customTheme.errorBorderColor : customTheme.defaultBorderColor), font.family["default"], font.size.px16, adjustToBackgroundColor ? colors.white : colors.dark, font.lineHeight.xs, spacing.px32, spacing.px8, inputBorderWidth, customTheme.hoverBorder, customTheme.hoverBorderColor, adjustToBackgroundColor ? colors.white : customTheme.activeBorderColor, customTheme.activeBorder,
  /* istanbul ignore next */
  (isFocused || ariaExpanded) && "border-color: ".concat(adjustToBackgroundColor ? colors.white : colors.dark, " !important;"), disabled && "\n    background-color: ".concat(customTheme.disabledFloatingBackgroundColor, ";\n    color: ").concat(customTheme.disabledColor, ";\n    -webkit-text-fill-color: ").concat(customTheme.disabledColor, ";\n    border-color: ").concat(customTheme.disabledBorderColor, ";\n    border-width: ").concat(customTheme.disabledBorder, ";\n    &:hover,\n    &:focus,\n    &:active {\n      border-color: ").concat(customTheme.disabledBorderColor, ";\n      border-width: ").concat(customTheme.disabledBorder, ";\n      outline: none;\n    }\n  "), hasTrailingIcon && "padding-right: 1.5rem;", hasLeadingIcon && "padding-left: 2.5rem;");
};
export var DEFAULT_FILE_UPLOAD_TYPES = ['.xlsx', '.xls', 'image/*', '.doc', '.docx', '.ppt', '.pptx', '.txt', '.pdf', 'text/plain', '.csv', '.rtf'];
export function useFileUploadBehavior(_ref3) {
  var onUploadFile = _ref3.onUploadFile,
      _ref3$acceptedTypes = _ref3.acceptedTypes,
      acceptedTypes = _ref3$acceptedTypes === void 0 ? DEFAULT_FILE_UPLOAD_TYPES : _ref3$acceptedTypes,
      selectMultiple = _ref3.selectMultiple;
  var inputRef = useRef(null);

  var onChangeInput = function onChangeInput(e) {
    /* istanbul ignore else */
    if (e && e.target && e.target.files) {
      var files = e.target.files;
      var filesCount = files.length;
      /* istanbul ignore else */

      if (filesCount) {
        for (var index = 0; index < filesCount; index++) {
          var file = files[index];
          onUploadFile(file);
        }
      }

      e.target.value = '';
    }
  };

  return {
    onTriggerUpload: function onTriggerUpload(e) {
      var input = inputRef.current;
      e.preventDefault();
      input.focus();
      input.click();
    },
    HiddenInput: /*#__PURE__*/React.createElement("input", {
      accept: acceptedTypes.join(','),
      style: {
        display: 'none'
      },
      ref: inputRef,
      type: "file",
      "aria-hidden": true,
      tabIndex: -1,
      onChange: onChangeInput,
      multiple: selectMultiple
    })
  };
}
export var getThemeConfig = function getThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return {
        defaultBorderColor: theme.colors.border.dark700,
        hoverBorderColor: theme.colors.border.dark900,
        activeBorderColor: theme.colors.border.dark900,
        disabledColor: theme.colors.border.medium500,
        disabledBackgroundColor: theme.colors.border.light200,
        disabledFloatingBackgroundColor: theme.colors.primary.light,
        disabledBorderColor: theme.colors.border.light200,
        errorBorderColor: theme.colors.error.dark,
        errorBackgroundColor: theme.colors.error.light,
        placeholderColor: theme.colors.border.dark700,
        lineHeight: theme.font.lineHeight.sm,
        height: theme.spacing.xl3,
        disabledPlaceholderColor: theme.colors.border.medium500,
        fontColor: theme.colors.border.dark900,
        borderRadius: theme.radius.sm,
        defaultBorder: '1px',
        hoverBorder: '1px',
        activeBorder: '1px',
        activeBoxShadow: "inset 0 0 0 1px ".concat(theme.colors.border.dark900),
        disabledBorder: '1px',
        errorBorder: '1px',
        errorBoxShadow: "inset 0 0 0 1px ".concat(theme.colors.error.dark),
        showCaretDownIcon: true
      };
    },
    fanta: {
      borderRadius: '0',
      defaultBorder: '2px',
      defaultBorderColor: colors.greyLight,
      hoverBorder: '2px',
      hoverBorderColor: colors.greyMedium,
      activeBorder: '2px',
      activeBoxShadow: 'none',
      activeBorderColor: colors.dark,
      disabledColor: colors.grey,
      disabledBackgroundColor: colors.greyLight,
      disabledBorder: '2px',
      disabledBorderColor: colors.greyLight,
      errorBorder: '2px',
      errorBoxShadow: 'none',
      errorBorderColor: colors.errorRed,
      errorBackgroundColor: colors.white,
      placeholderColor: colors.grey,
      showCaretDownIcon: false,
      lineHeight: font.lineHeight.md,
      height: spacing.px40,
      disabledPlaceholderColor: colors.grey,
      fontColor: colors.dark,
      disabledFloatingBackgroundColor: colors.greyLight
    },
    prop: themeProp
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/input/dist/esm/externals.js
// module id = 634
// module chunks = 11